/* eslint-disable max-len */
import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Wrapper = styled('div')`
border-radius 4px;
margin-top: ${(props) => (props.showPlaceholder && '8px')};
`;

const PlaceholderForVirtualizedList = React.memo(({
  measure, showPlaceholder, droppableId,
}) => {
  const placeholderInfo = useSelector((state) => state.calendar.data.placeholderInfo);
  const prevPlaceholderInfo = useRef(placeholderInfo);
  const droppableContainerCurrentlyHoveredByDraggedItem = useSelector((state) => state.calendar.data.droppableContainerCurrentlyHoveredByDraggedItem);

  useEffect(() => {
    if (!placeholderInfo || droppableContainerCurrentlyHoveredByDraggedItem !== droppableId) {
      /** this will measure on mount if the placeholder info is null or if the user is dragging over a different
       * droppable container
       * which means no drag is taking place
       * so the placeholder space created will be collapsed back to normall if
       * the drag ends or if the user drags over a different container
       */
      measure();
    }
    prevPlaceholderInfo.current = placeholderInfo;

    const prev = prevPlaceholderInfo.current;
    const curr = placeholderInfo;

    /** Case 1: showPlaceholder is true → always measure */
    /** Case 2: placeholderInfo goes from truthy → falsy → measure */
    if (measure && (showPlaceholder || (prev && !curr))) {
      measure();
    }

    prevPlaceholderInfo.current = curr;
  }, [measure, showPlaceholder, placeholderInfo, droppableContainerCurrentlyHoveredByDraggedItem]);

  return (
    <Wrapper
      style={{ height: (showPlaceholder && placeholderInfo?.height) || 1 }}
      showPlaceholder={showPlaceholder}
    />
  );
});

PlaceholderForVirtualizedList.propTypes = {
  measure: PropTypes.func.isRequired,
  showPlaceholder: PropTypes.bool.isRequired,
  droppableId: PropTypes.string.isRequired,
};

export default PlaceholderForVirtualizedList;
